module.exports = __webpack_public_path__ + "static/media/Queue.03134fc0.svg";